function DummyPromise() {}

DummyPromise.prototype.then = function () { return this }
DummyPromise.prototype.finally = function () { return this }
DummyPromise.prototype.catch = function () { }


export default DummyPromise
